import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import CurrencyDetailsForm from "../../../components/forms/setup/currencies/CurrenciesDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function CurrenciesViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [currencies, setCurrencies] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getCurrencies = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `currencies?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setCurrencies(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createCurrency = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("currencies/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Currency added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getCurrencies("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateCurrencies = async function (values, index) {
    let callResult = await makePutApiCall(`currencies/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Currency updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...currencies.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setCurrencies({ ...currencies, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddCurrencySlideOver = (isEdit, currency, index) => {
    setSlideOver({
      childComponent: (
        <CurrencyDetailsForm
          customerType={currency}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateCurrencies(payload, index) : createCurrency(payload)
          }
          title={isEdit ? `Update ${currency.name}` : "Add new currency"}
        />
      ),
      open: true,
    });
  };

  const deleteCurrency = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteCurrency/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = currencies.data.filter((item) => item.id !== id);
      setCurrencies({ ...currencies, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCurrency = function (currency, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCurrency(currency.id, index)}
          message={`Are you sure you want to delete  ${currency.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddCurrencySlideOver,
    getCurrencies,
    loading,
    currencies,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteCurrency,
  };
}
